import LinkButton from "components/common/LinkButton";

interface Props {
  text?: string;
  icon: string;
  className?: string;
  onClick: () => void;
  responsive?: boolean;
  responsiveBreakPoint?: "lg" | "md" | "xl";
}

export default function IconLinkButton({
  text,
  icon,
  className,
  responsive,
  responsiveBreakPoint,
  onClick,
}: Props) {
  return (
    <LinkButton
      className={`text-primaryRed ${className ?? ""}`}
      onClick={onClick}
    >
      <div className="inline-block">
        <img
          src={icon}
          className="inline mr-0 max-w-4"
          alt={`${text} action`}
          title={text}
        />
        {text && (
          <span
            className={`${
              responsive !== false
                ? `hidden ${responsiveBreakPoint}:inline`
                : "inline"
            } ml-1`}
          >
            {text}
          </span>
        )}
      </div>
    </LinkButton>
  );
}

IconLinkButton.defaultProps = {
  responsiveBreakPoint: "lg",
};
